import {checked_option_scroller} from '@bitstillery/common/lib/scroll'
import {classes} from '@bitstillery/common/lib/utils'
import {Icon, RadioGroup} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import {$t} from '@bitstillery/common/app'
import m from '@bitstillery/mithril'

import type {FilterSelectSingleState, FilterI18nResolved} from '@bitstillery/common/types'

interface FilterSelectSingleAttrs {
    className: string
    filter: FilterSelectSingleState
    filter_count?: boolean
    translate?: FilterI18nResolved | undefined
}

export class FilterSelectSingle extends MithrilComponent<FilterSelectSingleAttrs> {
    scroll_selection_into_view = checked_option_scroller()

    deactivate_filter(vnode: m.Vnode<FilterSelectSingleAttrs>) {
        vnode.attrs.filter.selection = ''
    }

    filtered_options(vnode: m.Vnode<FilterSelectSingleAttrs>) {
        return vnode.attrs.filter.options.filter((option) => {
            // Filter out inactive options; e.g. options that have no item count.
            if (option.length >= 3 && option[2] === 0) {
                return option[0] === vnode.attrs.filter.selection
            }
            return true
        })
    }

    override oncreate(vnode: m.Vnode<FilterSelectSingleAttrs>) {
        vnode.attrs.filter._active = () => {
            const {selection} = vnode.attrs.filter
            return selection !== undefined && selection !== null && selection !== ''
        }
    }

    view(vnode: m.Vnode<FilterSelectSingleAttrs>) {
        const filtered_options = this.filtered_options(vnode)
        return (
            <div
                className={classes('c-filter-select-single', 'filter', vnode.attrs.className, {
                    active: vnode.attrs.filter._active,
                    collapsed: vnode.attrs.filter.collapsed || vnode.attrs.filter.disabled,
                    disabled: filtered_options.length === 0 || vnode.attrs.filter.disabled,
                })}
            >
                <div
                    className='title'
                    onclick={() => {
                        vnode.attrs.filter.collapsed = !vnode.attrs.filter.collapsed
                    }}
                >
                    <div class='name'>
                        <div class='filter-icon'>
                            <Icon
                                active={vnode.attrs.filter._active}
                                className='btn-filter-toggle'
                                name={(() => {
                                    if (vnode.attrs.filter.icon) {
                                        return vnode.attrs.filter.icon
                                    }
                                    return vnode.attrs.filter.selection ? 'filterRemove' : 'filterPlus'
                                })()}
                                onclick={(e) => {
                                    e.stopPropagation()
                                    this.deactivate_filter(vnode)
                                }}
                                tip={() => {
                                    const filter_title = $t(vnode.attrs.filter.title)
                                    return vnode.attrs.filter._active
                                        ? $t('filters.actions.deactivate_filter', {name: filter_title})
                                        : $t('filters.inactive_filter', {name: filter_title})
                                }}
                            />
                        </div>
                        {$t(vnode.attrs.filter.title)}
                        {filtered_options.length === 0 && <span></span>}
                    </div>
                    <Icon
                        className='btn-collapse'
                        name={vnode.attrs.filter.collapsed ? 'chevronDown' : 'chevronUp'}
                        type='info'
                    />
                </div>
                <div
                    class='items'
                    oncreate={(items: m.VnodeDOM) => this.scroll_selection_into_view(items.dom)}
                    onupdate={(items: m.VnodeDOM) => this.scroll_selection_into_view(items.dom)}
                >
                    {filtered_options.length > 0 && (
                        <RadioGroup
                            disabled={vnode.attrs.filter.disabled}
                            model={vnode.attrs.filter.$selection}
                            ondeselect={() => this.deactivate_filter(vnode)}
                            options={filtered_options}
                            translate={vnode.attrs.translate}
                        />
                    )}
                </div>
            </div>
        )
    }
}
